import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "home-page" }
const _hoisted_2 = { class: "alarms-section card" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "alarms-header" }
const _hoisted_5 = {
  class: "card-title",
  title: "Alarm instances triggered off configured thresholds"
}
const _hoisted_6 = { class: "text-muted" }
const _hoisted_7 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_8 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_9 = {
  key: 2,
  class: "text-muted"
}
const _hoisted_10 = {
  key: 0,
  class: "alert alert-warning alarms-warning"
}
const _hoisted_11 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_12 = {
  key: 2,
  class: "table table-sm alarms-table"
}
const _hoisted_13 = {
  key: 3,
  class: "text-muted hidden-count"
}
const _hoisted_14 = { class: "grafanaContainer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_vue_feather = _resolveComponent("vue-feather")!
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, [
            _cache[1] || (_cache[1] = _createTextVNode(" Alarms ", -1)),
            _createElementVNode("small", _hoisted_6, "(last " + _toDisplayString(_ctx.historyDays) + " days)", 1)
          ]),
          _createVNode(_component_router_link, {
            to: "/alarms",
            class: "alarms-link"
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("View all on the Alarms page", -1)
            ]))]),
            _: 1
          })
        ]),
        (_ctx.alarmsLoading)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, "Loading alarms..."))
          : (!_ctx.alarmsAccessible)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, "Alarm information is not available for your account."))
            : (!_ctx.alarmsConfigured)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                  _cache[4] || (_cache[4] = _createTextVNode(" No alarms configured — thresholds can be set up on the ", -1)),
                  _createVNode(_component_router_link, { to: "/alarms" }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createTextVNode("Alarms page", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[5] || (_cache[5] = _createTextVNode(". ", -1))
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  (_ctx.grafanaError)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createVNode(_component_vue_feather, {
                          type: "alert-triangle",
                          size: "14"
                        }),
                        _createTextVNode(" " + _toDisplayString(_ctx.grafanaError), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.alarms.length === 0 && !_ctx.grafanaError)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_11, " No alarm instances in the last " + _toDisplayString(_ctx.historyDays) + " days. ", 1))
                    : _createCommentVNode("", true),
                  (_ctx.alarms.length > 0)
                    ? (_openBlock(), _createElementBlock("table", _hoisted_12, [
                        _cache[7] || (_cache[7] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", { scope: "col" }, "Severity"),
                            _createElementVNode("th", { scope: "col" }, "Threshold"),
                            _createElementVNode("th", { scope: "col" }, "Asset"),
                            _createElementVNode("th", { scope: "col" }, "Blade"),
                            _createElementVNode("th", { scope: "col" }, "Node"),
                            _createElementVNode("th", { scope: "col" }, "Fired at"),
                            _createElementVNode("th", { scope: "col" }, "Duration"),
                            _createElementVNode("th", { scope: "col" })
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alarms, (alarm, idx) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: idx,
                              class: _normalizeClass({ 'ongoing-row': alarm.timeEnd === 0 })
                            }, [
                              _createElementVNode("td", null, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(`severity-badge severity-${alarm.severity || 'warning'}`)
                                }, _toDisplayString(alarm.severity || "warning"), 3)
                              ]),
                              _createElementVNode("td", null, _toDisplayString(alarm.thresholdName), 1),
                              _createElementVNode("td", null, _toDisplayString(alarm.asset || "-"), 1),
                              _createElementVNode("td", null, _toDisplayString(alarm.blade || "-"), 1),
                              _createElementVNode("td", null, _toDisplayString(alarm.node || "-"), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.formatTime(new Date(alarm.time).toISOString(), false, false)), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.formatDuration(alarm.durationMs, alarm.time)), 1),
                              _createElementVNode("td", null, [
                                (alarm.dashboardUid)
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 0,
                                      to: _ctx.diagnosisLink(alarm.dashboardUid, alarm, alarm.selector),
                                      title: "open diagnosis dashboard around this alarm's time",
                                      target: "_blank",
                                      rel: "noopener"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_vue_feather, {
                                          type: "external-link",
                                          size: "12"
                                        }),
                                        _cache[6] || (_cache[6] = _createTextVNode(" Diagnosis ", -1))
                                      ]),
                                      _: 1
                                    }, 8, ["to"]))
                                  : _createCommentVNode("", true)
                              ])
                            ], 2))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.hiddenCount > 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                        _createTextVNode(_toDisplayString(_ctx.hiddenCount) + " more not shown — see the ", 1),
                        _createVNode(_component_router_link, { to: "/alarms" }, {
                          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                            _createTextVNode("Alarms page", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[9] || (_cache[9] = _createTextVNode(". ", -1))
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _withDirectives(_createVNode(_component_LoadingSpinner, null, null, 512), [
        [_vShow, !_ctx.iframeLoaded]
      ]),
      _withDirectives(_createElementVNode("iframe", {
        name: "farm-overview-iframe",
        id: "farm-overview-iframe",
        src: "/grafana/d/home-overview?orgId=1&kiosk",
        width: "100%",
        height: "100%",
        frameborder: "0",
        onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onIframeLoad && _ctx.onIframeLoad(...args)))
      }, null, 544), [
        [_vShow, _ctx.iframeLoaded]
      ])
    ])
  ]))
}